export default __webpack_public_path__ + "files/BC3.pdf";